module.exports = __webpack_public_path__ + "img/new.40a7f7ed.svg";